import React from 'react';

const CompanySelection = ({
  companies,
  selectedCompanies,
  onCompanySelect,
  onSelectAll,
  onClearAll
}) => {

  let finalCompanies = [];

  const COMPANY_THEME = {

    TATA: {
      primary: '#C8102E',
      light: '#fff5f6',
      isTata: true
    },
HDFC: {
  primary: 'rgb(34, 135, 94)',
  light: 'rgb(212, 236, 210)'
}

  };

  if (companies && companies.length > 0) {

    finalCompanies = companies.map(company => {
      return {
        ...company,
        key: company._id,
        name: company.name,
      };
    });

  } else {
    finalCompanies = [];
  }

  return (
    <>
      {companies && companies.length > 0 && (
        <>
          <div
            className="ctrl-row"
            style={{ marginBottom: '14px' }}
          >

            <button
              className="btn-sm"
              onClick={onSelectAll}
            >
              &#9989; Select All
            </button>

            <button
              className="btn-sm"
              onClick={onClearAll}
            >
              &#10006; Clear All
            </button>

          </div>

          <div className="company-grid">

            {finalCompanies.map((company) => {

              const isSelected =
                selectedCompanies[company._id];

          
              const companyType =
                (
                  company.tabName ||
                  company.companyName ||
                  company.name ||
                  ''
                ).toUpperCase();

       
              const theme =
                COMPANY_THEME[companyType] || {};

              // DEFAULT → BLUE
              const primaryColor =
                theme.primary || '#1A2B5F';

              const lightBg =
                theme.light || '#f0f3ff';

              const isTata =
                theme.isTata || false;

              return (
                <div
                  key={company._id}

                  className={`company-card ${
                    isSelected
                      ? `selected-${company.name}`
                      : ''
                  }`}

                  onClick={() =>
                    onCompanySelect(company._id)
                  }

                  style={{
                    borderColor: isSelected
                      ? primaryColor
                      : '#e0e0e0',

                    backgroundColor: isSelected
                      ? lightBg
                      : '#fff'
                  }}
                >

                  <div className="company-card-header">

                    <input
                      type="checkbox"

                      checked={isSelected || false}

                      onChange={() =>
                        onCompanySelect(company._id)
                      }

                      onClick={(e) =>
                        e.stopPropagation()
                      }
                    />

                    <div>

                      <div className="company-name">
                        {company.name}
                      </div>

                      <div
                        style={{ marginTop: '6px' }}
                      >

                        <span
                          style={{
                            backgroundColor:
                              primaryColor,

                            color: '#fff',

                            padding: '4px 10px',

                            borderRadius: '20px',

                            fontSize: '12px',

                            display: 'inline-block'
                          }}
                        >
                          {company.name}
                        </span>

                        {/* ⭐ ONLY FOR TATA */}
                        {isTata && (
                          <span
                            style={{
                              marginLeft: '8px',

                              backgroundColor:
                                '#FFC107',

                              color: '#000',

                              padding: '4px 10px',

                              borderRadius: '20px',

                              fontSize: '12px'
                            }}
                          >
                            ⭐ Our Product
                          </span>
                        )}

                      </div>

                      {company.product_name && (

                        <div
                          style={{
                            marginTop: '8px',

                            fontSize: '13px',

                            color: '#555'
                          }}
                        >
                          {company.product_name}
                        </div>

                      )}

                    </div>

                  </div>

                </div>
              );
            })}

          </div>
        </>
      )}
    </>
  );
};

export default CompanySelection;